import { render, staticRenderFns } from "./TimeOffSetting.vue?vue&type=template&id=4af676a9&scoped=true"
import script from "./TimeOffSetting.vue?vue&type=script&lang=js"
export * from "./TimeOffSetting.vue?vue&type=script&lang=js"
import style0 from "./TimeOffSetting.vue?vue&type=style&index=0&id=4af676a9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4af676a9",
  null
  
)

export default component.exports